import { apiPost } from "../shared/apiClient";

// Callers own the message-list shaping (broadcast normalization, dedup,
// reverse-chronological order) — this only fetches and unwraps the page.
export function fetchChatMessagesPage(payload) {
  return apiPost("/wati_messages/fetch_specific_chat_messages", payload)
    .then(res => {
      if (!res.data?.success) return [];
      return Array.isArray(res.data.data) ? res.data.data : (res.data.data?.data || []);
    })
    .catch(() => []);
}

export function sendTextMessage(payload) {
  return apiPost("/wati_messages/send_text_message", payload).then(res => res.data);
}

// `config` forwards extra axios options (e.g. onUploadProgress) straight
// through to apiPost — media sends track upload progress for the composer's
// progress bar.
export function sendImageMessage(payload, config = {}) {
  return apiPost("/wati_messages/send_image_message", payload, config).then(res => res.data);
}

export function sendVideoMessage(payload, config = {}) {
  return apiPost("/wati_messages/send_video_message", payload, config).then(res => res.data);
}

export function sendDocumentMessage(payload, config = {}) {
  return apiPost("/wati_messages/send_document_message", payload, config).then(res => res.data);
}

export function sendVoiceMessage(payload, config = {}) {
  return apiPost("/wati_messages/send_voice_message", payload, config).then(res => res.data);
}

export function sendTemplateMessage(payload) {
  return apiPost("/wati_messages/send_template", payload).then(res => res.data);
}

export function markChatAsRead(chatId) {
  return apiPost("/wati_messages/mark_chat_as_read", { chatId }).then(res => res.data);
}

export function markChatAsUnread(payload) {
  return apiPost("/wati_messages/mark_chat_as_unread", payload).then(res => res.data);
}
